export default __webpack_public_path__ + "static/media/AI-Development-Company.79093cbf.png";